/**
 * 微信支付图标。fill 走 currentColor，所以颜色由外层文字色决定：积分包按钮
 * 上是微信绿 #07C160，hover 反色时会跟着变白。
 */
export function WechatPayLogo({ className }: { className?: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			className={className}
			fill="currentColor"
			role="img"
			aria-label="WeChat Pay"
		>
			<path d="M22.74 6.58a0.5 0.5 0 0 0 -0.67 -0.09L8.89 15.65a0.69 0.69 0 0 1 -1 -0.23L4.41 9.37a0.7 0.7 0 0 1 0.11 -0.84 0.67 0.67 0 0 1 0.83 -0.12l3.85 2.14a0.51 0.51 0 0 0 0.48 0l10.77 -5.74a0.49 0.49 0 0 0 0.26 -0.39 0.48 0.48 0 0 0 -0.17 -0.42A13.07 13.07 0 0 0 12 1C5.38 1 0 5.5 0 11a9.2 9.2 0 0 0 3.44 7 0.24 0.24 0 0 1 0.09 0.22l-0.43 3.95a0.76 0.76 0 0 0 0.36 0.73 0.76 0.76 0 0 0 0.39 0.1 0.72 0.72 0 0 0 0.42 -0.13c0.11 -0.08 2.58 -1.76 3.43 -2.38a0.24 0.24 0 0 1 0.2 0 22.28 22.28 0 0 0 4.1 0.63c6.62 0 12 -4.5 12 -10a8.75 8.75 0 0 0 -1.26 -4.54Z" />
		</svg>
	);
}
